import type { ReadonlyRecord } from '../../../../utils'

import type { ValidOtp } from '../../../../domain'

export const mapOtpBodyRequest = (otp: ValidOtp): ReadonlyRecord<'otp', string> => ({ otp: otp.join('') })
export const mapBackupCodeBodyRequest = (backupCode: string): ReadonlyRecord<'backupCode', string> => ({ backupCode })
